import React from 'react';
import { Switch, Divider } from 'antd';
import { BellOutlined, UserOutlined, WarningOutlined, InfoCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import type { NotificationType } from '../../types/notification.types';
import { useAppStore } from '../../stores/useAppStore';

const notificationTypeConfig: Record<NotificationType, { label: string; icon: React.ReactNode; description: string }> = {
  'data-update': {
    label: 'Изменения данных',
    icon: <UserOutlined />,
    description: 'Уведомления об изменениях от других пользователей',
  },
  'system': {
    label: 'Системные',
    icon: <CheckCircleOutlined />,
    description: 'Системные уведомления и статус подключения',
  },
  'error': {
    label: 'Ошибки',
    icon: <WarningOutlined />,
    description: 'Критические ошибки и предупреждения',
  },
  'business': {
    label: 'Бизнес-события',
    icon: <InfoCircleOutlined />,
    description: 'Важные бизнес-события и напоминания',
  },
};

export const NotificationSettings: React.FC = () => {
  const isTypeEnabled = useAppStore((state) => state.isTypeEnabled);
  const toggleNotificationType = useAppStore((state) => state.toggleNotificationType);

  return (
    <div className="notification-settings">
      <div className="notification-settings-header">
        <BellOutlined style={{ fontSize: 16, marginRight: 6 }} />
        <h3 style={{ margin: 0, fontSize: 14, fontWeight: 600 }}>Настройки уведомлений</h3>
      </div>

      <Divider style={{ margin: '10px 0' }} />

      <div className="notification-settings-list">
        {(Object.entries(notificationTypeConfig) as [NotificationType, typeof notificationTypeConfig[NotificationType]][]).map(
          ([type, config]) => {
            const enabled = isTypeEnabled(type);
            
            return (
              <div key={type} className="notification-settings-item">
                <div className="notification-settings-item-content">
                  <div className="notification-settings-item-icon">{config.icon}</div>
                  <div className="notification-settings-item-text">
                    <div className="notification-settings-item-label">{config.label}</div>
                    <div className="notification-settings-item-description">{config.description}</div>
                  </div>
                </div>
                <Switch
                  checked={enabled}
                  onChange={() => toggleNotificationType(type)}
                  size="small"
                />
              </div>
            );
          }
        )}
      </div>

      <Divider style={{ margin: '10px 0' }} />

      <div style={{ padding: '6px 0', fontSize: 11, color: 'var(--color-text-disabled)', textAlign: 'center' }}>
        Настройки сохраняются автоматически
      </div>
    </div>
  );
};


